import React from 'react';
import { Table } from 'semantic-ui-react';
import { states } from '@/constants/lifecycle';
import TableWrapper from '@/components/table/TableWrapper';
import CompactTableHeader from '@/components/table/CompactTableHeader';
import TableErrorRow from '@/components/table/TableErrorRow';
import DatasetCollectionsAssignTableRows from './DatasetCollectionsAssignTableRows';

const DatasetCollectionsAssignTable = ({
  category,
  code,
  readStatus,
  collections,
  removeCollection,
  error,
  onErrorDismiss,
  children,
}) => (
  <TableWrapper className="aridhia-dataset-collections-assign-table" sticky>
    <Table.Header fullWidth>
      <CompactTableHeader
        isLoading={readStatus === states.PENDING}
        numberOfColumns={2}
        className="aridhia-dataset-collections-add-header"
        headerId="dataset.collections"
      />
      <TableErrorRow
        error={error}
        onErrorDismiss={onErrorDismiss}
        numberOfColumns={2}
      />
      { children }
    </Table.Header>
    <Table.Body>
      <DatasetCollectionsAssignTableRows
        category={category}
        code={code}
        items={collections}
        readStatus={readStatus}
        removeCollection={removeCollection}
      />
    </Table.Body>
  </TableWrapper>
);

export default DatasetCollectionsAssignTable;
